var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Offers",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.751,
    height: 36,
    viewBox: "0 0 28.751 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38197",
    "data-name": "Path 38197",
    d: "M14.744,2.58l-8.6,4.915L0,30.225,21.256,36,27.4,13.27l-4.915-8.6L17.939,3.44a4.72,4.72,0,0,1,2.7-.86h1.843c2.334,0,4.669,0,6.266-1.843L27.768,0c-1.106,1.352-3.195,1.352-5.283,1.352H20.519a5.374,5.374,0,0,0-4.055,1.72Zm.369,5.283a9.276,9.276,0,0,1,.369-2.826l-.369-.123L7.986,8.969,2.58,28.751l17.2,4.669,5.283-19.782h0L21.01,6.512,16.587,5.283a11.309,11.309,0,0,0-.246,2.334,3.4,3.4,0,0,1,1.106.123A4.147,4.147,0,0,1,19.9,9.584a4.082,4.082,0,0,1,.369,2.949,3.9,3.9,0,0,1-1.843,2.334,3.157,3.157,0,0,1-2.949.369,3.713,3.713,0,0,1-2.334-1.72,3.876,3.876,0,0,1-.491-3.072A4.4,4.4,0,0,1,14.5,8.109C14.744,7.986,14.867,7.986,15.113,7.863Zm3.072,4.177a1.643,1.643,0,0,1-.86.983,1.542,1.542,0,0,1-2.334-.614,1.706,1.706,0,0,1-.246-1.352,1.961,1.961,0,0,1,.86-1.106,1.691,1.691,0,0,1,1.352-.123,1.563,1.563,0,0,1,1.106.86A1.691,1.691,0,0,1,18.184,12.041Z",
    fill: "#282828",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/Offers.c84315bdc9de5461711d482f8a267d3f.svg";
export { ForwardRef as ReactComponent };